import { createSelector } from 'reselect'
import {
  VirtualCardPushTaskListModel,
  VirtualCardPushTaskListResponse,
} from 'src/models/virtualCardPushTask.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectVirtualCardPushTaskListResponsesFromState = (
  state: RootState,
): Record<string, VirtualCardPushTaskListResponse> =>
  state.data.virtualCardPushTasks.listResponses

export const selectVirtualCardPushTaskListModelsFromState = createSelector(
  [selectVirtualCardPushTaskListResponsesFromState],
  (virtualCardPushTaskListResponses) =>
    Object.values(virtualCardPushTaskListResponses).reduce<
      Record<
        VirtualCardPushTaskListResponse['taskId'],
        VirtualCardPushTaskListModel
      >
    >(
      (acc, curr) => ({
        ...acc,
        [curr.taskId]: new VirtualCardPushTaskListModel(curr),
      }),
      {},
    ),
)
